import React from 'react';
import Configuration from '../../utils/configuration';

export default function HeaderImage() {
	const bg = {
		backgroundImage: `url(${Configuration.RESOURCES_URL}static/bg_top_head.jpg)`
	};
	return (
		<div className="headerImage" style={bg}>
			<div className="headerImage-item">
				<img src={`${Configuration.RESOURCES_URL}static/elm_top_head.png`} alt="Imagen de cabecera" />
			</div>
			<div className="headerImage-item">
				<p>
					<span className="lead-font">26 DE SEPTIEMBRE</span> &bull; 19:30 H.
				</p>
			</div>
			<div className="headerImage-item">
				<p>LLAGAR DE CASTIELLO</p>
			</div>
		</div>
	);
}
